import {Area} from 'react-easy-crop';

const loadImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', reject);
    image.src = src;
  });

/**
 * Produces a square image cropped to the given pixel area and returns it as a File,
 * preserving the original mime type and file name. Used to guarantee a square avatar
 * before upload (backend only accepts square images).
 */
export const cropUtils = async (
  imageSrc: string,
  area: Area,
  mimeType: string,
  fileName: string
): Promise<File> => {
  const image = await loadImage(imageSrc);

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Could not get canvas context');
  }

  const size = Math.round(Math.min(area.width, area.height));
  canvas.width = size;
  canvas.height = size;

  context.drawImage(image, area.x, area.y, size, size, 0, 0, size, size);

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Canvas is empty'));
          return;
        }
        resolve(new File([blob], fileName, {type: mimeType}));
      },
      mimeType,
      0.92
    );
  });
};
